<template>
  <list-layout :tableTools="toggleTableTools">
    <template slot="header">
      <BaseHeader :content="header"/>
    </template>
    <template slot="table-core">
      <base-table-pagination
        :total="pagination.total"
        :currentPage="pagination.currentPage"
        :perPage="pagination.pageSize"
        @changeCurrentPage="changeCurrentPage"
        @changePerPage="changePerPage"
      ></base-table-pagination>
      <div class="flex flex-row w-100">
        <base-table-searches @toggleSearchesDialog="toggleSearchesDialog" />
        <base-table-search @toggleFilters="toggleFilters" />
      </div>
    </template>
    <template slot="table-tags">
      <base-table-filter-tags  :tags="tags" @removeTag="removeFilterTagHanlder" @removeAllTags="removeAllTagsHandler" @saveTags="saveTagsHandler"/>
    </template>
    <template slot="table-component">
      <kendo-grid-component
        :spanish="spanish"
        :dataResult='kendo.dataResult'
        :kendo="kendo"
        :loading='isGeneralLoading'
        :selectedField="selectedField"
        @datastatechange='dataStateChange'
        @columnreorder='columnReorder'
        @rowclick='openPath'
        @columnssubmit='onColumnsSubmit'
        @sortchange='sortChange'
        @filterchange='filterChange'
        @selectionchange="onSelectionChange"
        @headerselectionchange="onHeaderSelectionChange">
      </kendo-grid-component>
    </template>
    <template slot="layout-extend">
      <base-footer>
        <template slot="actions">
          <base-button-responsive mode='primary' :text="labelBtnExcel" icon='excelxls' @click='exportExcel' :loading='isGeneralLoading || loadingExcel' :disabled="loadingExcel"/>
        </template>
      </base-footer>
      <base-table-select-actions-expand
        :baseDropDownVisible="accionesFinales.length > 0"
        :visibility="hasSelected"
        :selected="rowsSelected"
        :total="rowsTotal"
      >
        <template slot="commons">
          <base-button size="xs" mode="tools" @click="unselect">
            <base-icon name="vall" size="sm" class="mr-1" />
            {{$t('app.unselect')}}
          </base-button>
        </template>
        <template slot="more">
          <span v-for="action in accionesFinales" :key="action.id">
              <base-button-item-list theme="dark"  @click="executeAction(action)">
                <base-icon :name="action.icon" class="mr-2" />
                {{ action.name }}
            </base-button-item-list>
          </span>
        </template>
      </base-table-select-actions-expand>
      <filter-panel :panelOpen="filterPanel" @togglePanel="toggleFilters" @applyFilters="applyFiltersHandler" />
      <create-search-dialog 
        :numberSearches="numberSearches"
        :idVista="idVista" 
        :dialogOpen="saveSearchDialog" 
        :tags="tags" 
        @toggleDialog="toggleDialogSearches" 
        @applyDialog="applySearchHandler" />
      <filter-panel-searches 
        ref="filterPanelSearches" 
        :idVista="idVista" 
        :vuexnamespace="vuexnamespace" 
        :panelOpen="searchesPanel" 
        @togglePanel="toggleSearchesDialog" 
        @applyFilters="applyFiltersHandler" 
        @updateNumberSearches="updateNumberSearches"/>
    </template>
  </list-layout>
</template>

<script>
import { i18n } from '@/i18n'
import ListLayout from '@/components/layout/ListLayout.vue'
import FilterPanel from '@/components/filters/UploadErrorsFilter.vue'
import FilterPanelSearches from '@/components/searches/SearchesPanel.vue'
import CreateSearchDialog from '@/components/searches/CreateSearchDialog.vue'
import { getUploadInvoiceErrors } from '@/services/invoices/getUploadInvoiceErrors'
import { process } from '@progress/kendo-data-query'
import setNestedValue from '@/services/functions/setNestedValue'
import hasNestedValue from '@/services/functions/hasNestedValue'
import KendoGridComponent from '../../components/KendoGridComponent.vue'
import { exportExcel } from '@/services/excel/exportExcel'
import _ from 'lodash'
export default {
  name: 'uploaded-invoices-list-view',
  components: {
    ListLayout,
    FilterPanel,
    FilterPanelSearches,
    CreateSearchDialog,
    KendoGridComponent,
  },
  data: function () {
    return {
      idVista: 54,
      // Searches
      numberSearches: 0,
      saveSearchDialog: false,
      searchesPanel: false,
      // All
      accionesBase: [
        {
          id: 1,
          icon: 'editpencil',
          name: i18n.t('app.modify')
        },
        {
          id: 2,
          icon: 'retry',
          name: i18n.t('tipos.accion.retry')
        },
        {
          id: 3,
          icon: 'check',
          name: i18n.t('app.check_as_readed')
        },
      ],
      loadingExcel: false,
      spanish: true,
      showModal: false,
      header: {
        title: i18n.t('avisos.upload_errors.header'),
        icon: 'docblack',
        breadcrumb: null,
        url: null
      },
      vuexnamespace: 'uploaderrors',
      hasClientFilterData: false,
      selectedField: 'selected',
      onlySelected: false,
      filterPanel: false,
      showAllRows: true,
      loadingDataTable: false,
      data: null,
      tableData: [],
      selected: [],
    }
  },
  computed: {
    isClientFilterActive () {
      return this.$store.getters[this.vuexnamespace + '/isClientFilterActive']
    },
    actualFilterNav () {
      return this.$store.getters['app/idClienteFilterNav']
    },
    accionesFinales () {
      // TODO - Realizar acciones 1 y 2
      const acciones = this.accionesBase.filter(x => x.id === 3)
      if (this.selected !== undefined && this.selected !== null && this.selected.length > 1) {
        return acciones.filter(x => [2, 3].includes(x.id))
      }
      return acciones
    },
    labelBtnExcel: function () {
      if (this.hasSelected) return `${i18n.t('app.export_excel')} (${i18n.t('app.selected')})`
      return i18n.t('app.export_excel')
    },
    kendo: function () {
      return this.$store.getters[this.vuexnamespace + '/getKendo']
    },
    isHeadCoreReady: function () {
      return this.$store.getters.isHeadCoreReady
    },
    toggleTableTools: function () {
      return this.selected.length > 0
    },
    rowsSelected: function () {
      return this.selected.length
    },
    rowsTotal: function () {
      return this.selected.length
    },
    masterFilters: function () {
      return this.$store.getters[this.vuexnamespace + '/getMasterFilters']
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    headerCoreFilters: function () {
      return this.$store.getters['auth/queryHeaders']
    },
    tags: function () {
      return this.$store.getters[this.vuexnamespace + '/getTags']
    },
    pagination: function () {
      return this.$store.getters[this.vuexnamespace + '/getPaginationInfo']
    },
    areAllSelected () {
      return this.data.length === this.selected.length
    },
    hasSelected () {
      return this.selected.length > 0
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    isRoleUserOrConsulta: function () {
      return this.role === 1 || this.role === 4
    },
  },
  watch: {
    $route (to, from) {
      this.updateOnRouteChange(to, from)
      // this.routerChangeHandler()
    },
    headerCoreFilters: {
      // immediate: true,
      deep: true,
      handler: 'headerCoreFiltersHandler'
    },
    data (val, oldVal) {
      const dataState = {
        skip: this.kendo.skip,
        take: this.kendo.take,
        sort: this.kendo.sort,
        group: this.kendo.group
      }
      const localGroups = dataState.group || []
      const localData = val || []
      if (localData.length && localGroups.length) {
        localData.forEach(x => {
          localGroups.forEach(group => {
            if (!hasNestedValue(group.field, x, { checkNull: true, checkUndefined: true })) {
              setNestedValue(group.field, x, '')
            }
          })
        })
      }
      this.kendo.dataResult = process(localData, dataState)
      this.unselect()
    }
  },
  created: function () {
    if (this.isRoleUserOrConsulta) {
      this.kendo.columns = this.kendo.columns.filter(x => x.field !== 'selected')
    } 
    // if (this.isRoleUserOrConsulta) this.kendo.columns.shift()
    if (this.$route.params.data) {
      this.filterByParamsData()
    }
  },
  mounted: async function () {
    // this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
    // this.$store.commit(this.vuexnamespace + '/resetMasterFilters')
    this.$store.commit(this.vuexnamespace + '/setPageSize', this.kendo.take)
    if (this.actualFilterNav && this.isClientFilterActive && !this.hasClientFilterData) {
      const filter = this.masterFilters
      filter.empresa = { label: i18n.t('uploaderrors.cliente'), value: this.actualFilterNav, compareType: 'function', callback: (item, value, key) => item?.cliente?.idCliente === value }
      this.$store.commit(this.vuexnamespace + '/setMasterFilters', filter)
    }
    this.data = await this.applyFilters()
  },
  methods: {
    filterByParamsData: function () {
      const data = this.$route.params.data
      const filters = {}
      if (data) {
        data.filters.forEach(filter => {
          if (filter.type === 'cliente') {
            this.hasClientFilterData = true
            const cliente = { label: i18n.t('clients.entity_name'), value: { Nombre: filter.data.label, idCliente: filter.data.id }, compareType: 'function', callback: (item, value, key) => item?.cliente?.idCliente === value }
            filters.empresa = cliente
          } else {
            filters[filter.type] = filter.data
          }
        })
        this.$store.commit(this.vuexnamespace + '/setMasterFilters', filters)
      }
    },
    executeAction: async function (action) {
      this.selectedAction = action
      if (this.selectedAction.id === 1) { // Modificar

      } else if (this.selectedAction.id === 2) { // Reintentar
        
      } else { // Marcar como leido
        this.data = this.data.filter(x => !this.selected.includes(x))
        if (this.data.length === 0) {
          this.$store.dispatch('app/removeAnnouncement', 'notices/uploaderrors')
        } else {
          this.$store.dispatch('app/updateAnnouncement', { link: 'notices/uploaderrors', params: this.data, NumeroAvisos: this.data.length })
        }
        this.applyFilters()
      }
    },
    updateAllSelectedHeader: function () {
      if (!this.hasSelected) {
        this.kendo.columns[0].headerSelectionValue = false
      } else {
        this.kendo.columns[0].headerSelectionValue = this.areAllSelected
      }
    },
    updateOnRouteChange: async function (to, from) {
      await this.applyFilters()
    },
    openPath: function (event) {
      
    },
    toggleFilters: function () {
      this.filterPanel = !this.filterPanel
    },
    removeFilterTag: function (tag) {
      this.tags.splice(this.tags.indexOf(tag), 1)
    },
    createAppState: function (dataState) {
      this.kendo.take = dataState.take
      this.kendo.skip = dataState.skip
      if (dataState.group) {
        // eslint-disable-next-line no-return-assign
        // dataState.group.map(group => group.aggregates = this.aggregates)
      }
      this.kendo.group = dataState.group
      this.kendo.filter = dataState.filter
      this.kendo.sort = dataState.sort
    },
    dataStateChange: async function (event) {
      this.createAppState(event.data)
      this.data = await this.applyFilters()
    },
    columnReorder: function (options) {      
      this.sendUpdatedColumns(options.columns)
      this.kendo.columns.forEach((column, index) => {
        if (options.columns.filter(x => x.field === column.field).length === 0) {
          column.orderIndex = index + this.kendo.columns.length
          options.columns.push(column)
        }
      })
      this.kendo.columns = options.columns
    },
    exportExcel: async function () {
      this.$store.commit('app/setLoading', true)
      this.loadingExcel = true
      try {
        var data = []
        if (this.selected.length > 0) {
          data = this.selected
        } else {
          const pageSize = this.pagination.pageSize
          const currentPage = this.pagination.currentPage
          const filters = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
          const extraparams = _.cloneDeep(filters)
          Object.entries(extraparams).forEach(([key, value]) => { extraparams[key] = this.discard(['label', 'value'], value) })
          const params = {
            empresa: filters.empresa?.value?.idCliente,
            'distribuidor.idDistribuidor': filters['distribuidor.idDistribuidor']?.value?.idDistribuidor,
            Respuesta: filters.Respuesta?.value,
            codError: filters.codError?.value,
            msgError: filters.msgError?.value,
            extraparams,
            paginate: false
          }
          const objOrder = this.getObjOrderMixin(this.kendo.group, this.kendo.sort, true)
          try {
            data = await this.getItemsData(objOrder, params)
          } catch (error) {
            this.$store.commit('setIsLoading', false)
            this.doFeedback(i18n.t('feedback.error.general'))
          }
          this.$store.commit(this.vuexnamespace + '/setCurrentPage', currentPage)
          this.$store.commit(this.vuexnamespace + '/setPageSize', pageSize)
        }
        exportExcel({
          data: data.map(x => ({ facturaName: x.Respuesta, success: !x.blnError, codError: x.codError, msgError: x.msgError })),
          fileName: 'subidas-en-error.csv' 
        })
      } catch (error) {
        console.error(error)
        if (error.response?.data) {
          const errorText = await error.response.data.text()
          this.doFeedback(errorText)
        } else {
          this.doFeedback()
        }
      } finally {
        this.$store.commit('app/setLoading', false)
        this.loadingExcel = false
      }
    },
    onColumnsSubmit: function (columnsState) {
      this.sendUpdatedColumns(columnsState)
      this.kendo.columns = columnsState
    },
    sortChange: function (e) {
      let sort = e.sort
      if (Array.isArray(e)) {
        sort = e
      }
      const dataState = {
        skip: this.kendo.skip,
        take: this.kendo.take,
        sort: sort,
        group: this.kendo.group,
        filter: this.kendo.filter
      }
      this.dataStateChange({ data: dataState })
    },
    filterChange: function (filter) {
      const dataState = {
        skip: this.kendo.skip,
        take: this.kendo.take,
        sort: this.kendo.sort,
        group: this.kendo.group,
        filter: filter
      }

      this.dataStateChange({ data: dataState })
    },
    expandChange: function (event) {
      event.dataItem[event.target.$props.expandField] = !event.dataItem[event.target.$props.expandField]
    },
    applyFilters: async function (eventData) {
      this.loadingDataTable = true
      const data = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      this.$store.commit(this.vuexnamespace + '/setClientFilterActive', !!((data.empresa && data.empresa.value.idCliente === this.actualFilterNav?.idCliente) || (this.hasClientFilterData)))
      const extraparams = _.cloneDeep(data)
      Object.entries(extraparams).forEach(([key, value]) => { extraparams[key] = this.discard(['label', 'value'], value) })
      const params = {
        empresa: data.empresa ? data.empresa.value.idCliente : null,
        'distribuidor.idDistribuidor': data['distribuidor.idDistribuidor'] ? data['distribuidor.idDistribuidor'].value.idDistribuidor : null,
        Respuesta: data.Respuesta ? data.Respuesta.value : null,
        codError: data.codError ? data.codError.value : null,
        msgError: data.msgError ? data.msgError.value : null,
        extraparams
      }
      const objOrder = this.getObjOrderMixin(this.kendo.group, this.kendo.sort, true)
      try {
        this.data = await this.getItemsData(objOrder, params)
      } catch (error) {
        this.$store.commit('setIsLoading', false)
        this.doFeedback(i18n.t('feedback.error.general'))
      }

      // if (this.data !== null) {
      //   this.data.forEach(o => {
      //     o.FechaCaducidad = moment(o.FechaCaducidad).format('DD-MM-yyyy HH:mm')
      //   })
      // }
      this.updateAllSelectedHeader()
      return this.data
    },
    getItemsData: async function (orders, filters) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      const params = {
        paginate: true,
        results: this.pagination.pageSize,
        page: this.pagination.currentPage,
        ...filters
      }
      const res = await this.getMainData(orders, params)
      if (res.blnError === false) {
        this.data = res.respuesta
        const pagination = {
          total: res.meta?.total,
          currentPage: res.meta?.currentPage,
          totalPages: res.meta?.lastPage,
          pageSize: res.meta?.perPage
        }
        this.$store.commit(this.vuexnamespace + '/setPaginationInfo', pagination)
        this.$store.commit('setIsLoading', false)
      } else {
        this.doFeedback(`${res.msgError} [${res.codError}]`)
      }
      this.loadingDataTable = false
      return this.data
    },
    async getMainData (orders, filters) {
      const data = getUploadInvoiceErrors(orders, filters)
      return data
    },
    applyFiltersHandler: async function (eventData) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.data = await this.applyFilters(eventData)
    },
    changeCurrentPage: async function (event) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', event)
      this.data = await this.applyFilters(null)
    },
    changePerPage: async function (event) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.$store.commit(this.vuexnamespace + '/setPageSize', event)
      this.kendo.take = event
      this.data = await this.applyFilters(null)
    },
    removeFilterTagHanlder: function (tag) {
      // this.$store.commit(this.vuexnamespace + '/removeTag', tag)
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      const filter = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      delete filter[tag[0]]
      this.$store.commit(this.vuexnamespace + '/setMasterFilters', filter)
      this.applyFiltersHandler(null)
    },
    headerCoreFiltersHandler: function (obs) {
      if (this.isHeadCoreReady) {
        this.applyFilters(null)
      }
    },
    removeAllTagsHandler: function () {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.$store.commit(this.vuexnamespace + '/resetMasterFilters')
      this.applyFiltersHandler(null)
    },
    tableSortByChangeHandler: function ({ prop, order }) {
      this.$store.commit(this.vuexnamespace + '/setSort', prop)
      this.$store.commit(this.vuexnamespace + '/setSortOrder', order)
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.applyFilters(null)
    },
    unselect: function () {
      if (this.kendo.dataResult) {
        const checked = false
        this.mapSelectionKendoGrouping(checked)
        this.updateAllSelectedHeader()
      }
    },
    onHeaderSelectionChange: function (event) {
      const checked = event.event.target.checked
      this.mapSelectionKendoGrouping(checked)
      this.updateAllSelectedHeader()
    },
    onSelectionChange: function (event) {
      event.dataItem[this.selectedField] = !event.dataItem[this.selectedField]
      this.selected = event.dataItems.filter(d => d.selected === true)
      this.updateAllSelectedHeader()
    },
    toggleSearchesDialog: function () {
      this.searchesPanel = !this.searchesPanel
    },
    saveTagsHandler: function () {
      this.saveSearchDialog = !this.saveSearchDialog
    },
    toggleDialogSearches: function () {
      this.saveSearchDialog = !this.saveSearchDialog
    },
    applySearchHandler: async function () {
      this.toggleDialogSearches()
      // Manda actualizar lista de búsquedas
      this.$refs.filterPanelSearches.updateData()
    },
    updateNumberSearches: async function (number) {
      this.numberSearches = number
    },
  }
}
</script>

<style lang="scss" scoped></style>
